const map = {
	"./aquaculture.svg": 8548,
	"./arrow-right.svg": 352,
	"./close.svg": 369,
	"./language.svg": 3604,
	"./menu.svg": 2003,
	"./pause-squared.svg": 2556,
	"./play-squared.svg": 1748,
	"./print.svg": 9355,
	"./search.svg": 4258,
	"./toggle.svg": 2986,
	"./wildfish.svg": 9712
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9477;